module.exports = __webpack_public_path__ + "static/media/SparkasseBd.7ee1088c.ttf";